import Link from 'gatsby-link';
import TweenLite from "gsap/umd/TweenLite.js";
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { containers, fontSize, MixBlendDifference, MixBlendText } from 'style';
import { MethodsService } from 'utils';



class LinkBarComponent extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            cursor: 'default',
        };
        this.magnetize = this.magnetize.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }
    componentDidMount() { }

    magnetize(e) {
        var mX = e.clientX,
            mY = e.clientY;
        var bounds = this.circle.getBoundingClientRect();

        const customDist = 7 * 20 || 120;
        const centerX = bounds.left + bounds.width / 2;
        const centerY = bounds.top + bounds.height / 2;

        var deltaX = Math.floor(centerX - mX) * -0.75;
        var deltaY = Math.floor(centerY - mY) * -0.45;

        var distance = this.calculateDistance(bounds, mX, mY);
        if (distance < customDist) {
            TweenLite.to(this.circle, 0.5, {
                y: deltaY,
                x: deltaX,
                scale: 1.1,
            });
        } else {
            this.resetCircle();
        }
    }
    calculateDistance(bounds, mouseX, mouseY) {
        return Math.floor(
            Math.sqrt(
                Math.pow(mouseX - (bounds.left + bounds.width / 2), 2) +
                Math.pow(mouseY - (bounds.top + bounds.height / 2), 2)
            )
        );
    }
    resetCircle() {
        TweenLite.to(this.circle, 0.6, { y: 0, x: 0, scale: 1 });
    }
    onMouseLeave(e) {
        this.resetCircle();
    }
    render() {
        const { link, linkText } = this.props;
        return (
            <div id="LinkBarComponent">
                <Link
                    to={`/${link && link.slug}`}
                    data-cursor={this.state.cursor}
                    data-cursor-persistance="200">
                    <LinkBar>
                        <HotSpot
                            onMouseMove={this.magnetize}
                            onMouseLeave={this.onMouseLeave}>
                            <Circle /*removed innerRef*/ ref={el => (this.circle = el)} />
                            <Text className="h1">{linkText}</Text>
                        </HotSpot>
                    </LinkBar>
                </Link>
            </div>
        );
    }
}

const circleHeightModuleMobile = 100;
const circleHeightModule = 7;
const circleHeight = 8;

const LinkBar = styled.div`
    text-align: center;
    width: 100%;
    isolation: isolate;
    position: relative;
    align-items: center;
    background-color: #fff;
    color: #fff;
    text-decoration: none;
    z-index: 1;
`;

const HotSpot = styled.div`
    height: 300px;
    width: 100%;
    position: relative;
    outline: 0;
    margin: -56px 0;
`;
const Circle = styled.div`
    margin-top: -5px;
    height: ${circleHeightModuleMobile}px;
    width: ${circleHeightModuleMobile}px;
    margin-left: -${circleHeightModuleMobile / 2}px;
    margin-top: -${circleHeightModuleMobile / 2}px;
    left: 50%;
    top: 50%;
    @media (min-width: ${containers.small}px) {
        margin-top: -5px;
        height: ${circleHeight}vw;
        width: ${circleHeight}vw;
        margin-left: -${circleHeight / 2}vw;
        margin-top: -${circleHeight / 2}vw;
    }
    @media (min-width: ${containers.outerPX}px) {
        margin-top: -5px;
        height: ${circleHeight}vw;
        width: ${circleHeight}vw;
        margin-left: -${circleHeight / 2}vw;
        margin-top: -${circleHeight / 2}vw;
    }
    border: 1px solid #000;
    @supports (mix-blend-mode: difference) {
      background-color: #000;
    }

    border-radius: 100%;
    position: absolute;
    outline: 0;
`;

const Text = styled.div`
    ${MixBlendDifference};
    ${MixBlendText({
    fallbackcolor: '#000',
    fallbackshadowcolor: 'transparent',
})};
    white-space: nowrap;
    /* font-size: ${fontSize(32)};

    @media (min-width: ${containers.outerPX}px) {
        font-size: ${fontSize(40)};
    } */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
`;

export default LinkBarComponent;
